/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2580
 */

module.exports = function (e) {
  return function () {
    return e
  }
}
